import HeroSection from '../components/HeroSection';
import FeatureGrid from '../components/FeatureGrid';
import FeatureGrid2 from '../components/feturegrid2';
import PricingTable from '../components/PricingTable';
import FreeDemo from '../components/FreeDemo';
import Footer from '../components/faq';
import PowerdBy from '../components/powerdBy';
import Navbar from '../auth/navBar';

export default function LandingPage() {
  return (
    <>
      <div className="min-h-screen bg-white font-sans">
        <Navbar />
        <HeroSection />
        {/* <FeatureGrid /> */}
        <FeatureGrid2 />
        {/* <PricingTable /> */}
        <FreeDemo />
        <Footer />
        {/* <Master /> */}
        {/* <Footer /> */}
      </div>
    </>
  );
}
